module.exports = __webpack_public_path__ + "img/inst-13.0ff64932.png";